import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { ClientAndInvestmentAccountDto } from './dto';
import { mapClientAndInvestmentAccountListDtoToModel } from './mappers';
import type { ClientAndInvestmentAccount } from './models';

export const getClientsWithAccounts = async (): Promise<
  GenericResponse<ApiResponse<ClientAndInvestmentAccount[]>>
> => {
  try {
    const response = await wtClientApi.get<ClientAndInvestmentAccountDto[]>(
      '/management/clients/withAccounts',
    );

    const mappedData = mapClientAndInvestmentAccountListDtoToModel(
      response.data ?? [],
    );

    const mappedResponse: ApiResponse<ClientAndInvestmentAccount[]> = {
      data: mappedData,
      status: 'OK',
      message: 'OK',
      pagination: null,
    };

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener los datos del cliente con cuentas',
    );
  }
};
